<div class="leftpanel">
  <div class="sidenav-user" *ngIf="userData">
    <h4 class="sidenav-user-name">
      {{ commonService.getFullName(userData?.firstName, userData?.lastName) }}
    </h4>
    <div class="profileimgsec">
      <img class="sidenav-user-image" src="{{ userData?.profilePicture }}" />
    </div>

    <h5 class="sidenav-user-email">
      <mat-icon> place</mat-icon> {{ userData?.userCompany?.companyAddress }},
      {{ userData?.userCompany?.state }}, {{ userData?.userCompany?.city }},
      {{ userData?.userCompany?.zipCode }}
    </h5>
    <h5 class="sidenav-user-email">
      <mat-icon> email</mat-icon> {{ userData?.emailAddress }}
    </h5>
    <h5 class="sidenav-user-email">
      <mat-icon> phone</mat-icon>
      {{ userData?.phoneNumber | mask : "(000) 000-0000" }}
    </h5>
    
    <div class="status_review" *ngIf="statusLight?.status === 'Past Due'" [class]="statusLight?.color">
      <div class="left">
          <h3>
              Past Due
          </h3>
      </div>
      <div style="margin-left: -50px;">
          <small>
              {{statusLight.totalCount}} Payments
          </small>
      </div>
      <div class="currency">
          {{statusLight.totalDue| currency}} 
      </div>
  </div>
    <div class="status_review" *ngIf="statusLight?.status === 'Cancelled'" [class]="statusLight?.color">
      <div class="left">
          <h3>
              Cancelled 
          </h3>
      </div>
      <div>
          <small>
              {{statusLight.totalCount}} Cancelled Agreements
          </small>
      </div>
  </div>
  <div class="status_review" *ngIf="statusLight?.status === 'Expired'" [class]="statusLight?.color">
      <div class="left">
          <h3>
              Expired 
          </h3>
      </div>
      <div>
          <small>
              {{statusLight.totalCount}} Expired Agreements
          </small>
      </div>
  </div>
  <div class="status_review" *ngIf="statusLight?.status === 'Declined'" [class]="statusLight?.color">
      <div class="left">
          <h3>
              Declined 
          </h3>
      </div>
      <div>
          <small>
              {{statusLight.totalCount}} Declined Agreements
          </small>
      </div>
  </div>
  <div class="status_review" *ngIf="statusLight?.status === 'Pending Payment'" [class]="statusLight?.color">
      <div class="left">
          <h3>
              Pending Payment  
          </h3>
      </div>
      <div style="margin-left: -50px;">
          <small>
              {{statusLight.totalCount}} Pending Payments
          </small>
      </div>
      <div class="currency">
          {{statusLight.totalDue| currency}}
      </div>
  </div>
    <!-- <span class="status" [class]="statusLight?.color">{{statusLight?.status}}</span> -->
  </div>
  <div class="billing_prt">
    <mat-accordion>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        expanded
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="panel-title main-title">Claim Details</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info_panel">
          <div class="diverder">
            <span>
              <label> Claim number: </label>
              <span class="answer_text"> {{ claims?.fileClaimNumber }} </span>
            </span>
            <span>
              <label> Covered item: </label>
              <span class="answer_text"> {{ claims?.coveredItem }} </span>
            </span>

            <!-- QUESTION SECTION START -->
            <div class="question_prt">
              <ng-container *ngFor="let item of claims?.firstQestions">
                <span>
                  <label>
                    {{ item?.question_details?.title }}
                  </label>
                  <p class="answer_text">
                    {{
                      item?.question_details?.type == "Yes/No"
                        ? item.answer
                          ? "Yes"
                          : "No"
                        : item?.answer
                    }}
                  </p>
                </span>
              </ng-container>

              <ng-container *ngFor="let item of claims?.additionalQuestions">
                <span>
                  <label>
                    {{ item?.question_details?.title }}
                  </label>
                  <p class="answer_text">
                    {{
                      item?.question_details?.type === "Yes/No"
                        ? item.answer
                          ? "Yes"
                          : "No"
                        : item?.question_details?.type === "Date"
                        ? (item?.answer | date : "MMM dd, YYYY")
                        : item?.answer
                    }}
                  </p>
                </span>
              </ng-container>

              <ng-container *ngFor="let item of claims?.answerDetails">
                <span>
                  <label>
                    {{
                      item.claim_question_answer_details[0]?.quetion?.question
                    }}
                  </label>
                  <p
                    class="answer_text"
                    *ngFor="let answer of item?.claim_question_answer_details"
                  >
                    {{ answer?.answer }}
                  </p>
                  <p class="answer_text" *ngIf="claims?.otherAnswer">
                    {{ claims?.otherAnswer }}
                  </p>
                </span>
              </ng-container>
            </div>
            <!-- QUESTION SECTION END -->
            <span>
              <label> Coverage Benefits: </label>
              <span class="answer_text">
                {{ otherInfo?.coverageBenefits | currency }}
              </span>
            </span>
            <span>
              <label> Available Benefits: </label>
              <span class="answer_text">
                {{ otherInfo?.availableBenefits | currency }}
              </span>
            </span>
            <span>
              <label> Assigned Concierge: </label>
              <span class="answer_text">
                {{
                  commonService.getFullName(
                    claims?.assignedConcierge?.firstName,
                    claims?.assignedConcierge?.lastName
                  )
                }}</span
              >
            </span>
          </div>
          <!-- <div class="diverder">
                    <span>
                      <label> Claim number: </label>
                      <b> EHW-FC-86081720595144 </b>
                    </span>
                    <span>
                      <label> Covered item: </label>
                      <b> Refrigerator Including Ice Maker & Water Dispenser </b>
                    </span>
                    <span>
                      <label> Age of the item: </label>
                      <b> 2 </b>
                    </span>
                    <span>
                      <label> Model #: </label>
                      <b> 123 </b>
                    </span>
                    <span>
                      <label> Serial number: </label>
                      <b> 2 </b>
                    </span>
                    <span>
                      <label> Issue: </label>
                      <b>
                        Lorem Ipsum is simply dummy text of the printing and typesetting
                        industry.
                      </b>
                    </span>
                    <span>
                      <label> Coverage Benefits: </label>
                      <b> test_one </b>
                    </span>
                    <span>
                      <label> Available Benefits: </label>
                      <b> test </b>
                    </span>
                    <span>
                      <label> Assigned Concierge: </label>
                      <b> test </b>
                    </span>
                  </div> -->
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="panel-title main-title">Urgent Tasks</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="task_panel">
          <div class="panel">
            <h4>Open Notes</h4>
            <ng-container *ngFor="let item of claims?.note">
              <div class="ansprt">
                <p>
                  {{ item?.notes }}
                </p>
                <span (click)="openViewModal(item, 'note')">View</span>
              </div>
            </ng-container>

            <div class="ansprt" *ngIf="!claims?.note?.length">
              <p style="color: red">No open notes available</p>
            </div>
          </div>
          <div class="panel">
            <h4>Requests</h4>
            <ng-container *ngFor="let item of claims?.specialRequest">
              <div class="ansprt">
                <p>
                  {{ item?.request }}
                </p>
                <span (click)="openViewModal(item, 'request')">View</span>
              </div>
            </ng-container>

            <div class="ansprt" *ngIf="!claims?.specialRequest?.length">
              <p style="color: red">No requests available</p>
            </div>
          </div>
          <div class="panel">
            <h4>Required action</h4>
            <div class="ansprt" *ngIf="otherInfo?.urgentTask">
              <p>
                {{ otherInfo?.urgentTask?.note }}
              </p>
              <span (click)="openViewModal(otherInfo?.urgentTask, 'urgentTask')"
                >View</span
              >
            </div>
            <div class="ansprt" *ngIf="!otherInfo?.urgentTask">
              <p style="color: red">No required action available</p>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
